import React from "react";
import { makeStyles } from "@material-ui/core/styles";

export function Divider({
  text,
  textColor = "#908F8F",
  fontSize = 14,
  dividerLine = "1px solid #C2C5C7",
  margin,
  padding,
  width = "100%",
}) {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      alignItems: "center",
      margin: margin,
      padding: padding,
      width: width,
    },
    border: {
      borderBottom: dividerLine,
      flex: "1",
    },
    content: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      fontWeight: 500,
      fontSize: fontSize,
      color: textColor,
      fontFamily: "Lato, sans-serif",
    },
  }));

  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.border} />
      {text && <span className={classes.content}>{text}</span>}
      <div className={classes.border} />
    </div>
  );
}

export default Divider;
